import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setAnalyticsUser } from "../utils/analytics";

/* The signed-in customer's id, in either shape the auth endpoints return. */
export const customerIdOf = (currentUser) =>
  currentUser?.result?._id || currentUser?._id || currentUser?.user?._id || null;

/**
 * Keeps GA4's User-ID in step with the signed-in account: set on sign-in and
 * on load with a stored session, cleared on sign-out. Mounted once in App.
 */
export default function useAnalyticsUser() {
  const customerId = useSelector((state) => customerIdOf(state.user?.currentUser));
  useEffect(() => {
    setAnalyticsUser(customerId);
  }, [customerId]);
}
